import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';
export const ConversationAssigned = ({ entry, }) => {
    var _a;
    const agentLink = (_jsx(UserLink, Object.assign({ userId: entry.agent_id }, { children: (_a = entry.agent_name) !== null && _a !== void 0 ? _a : entry.agent_id })));
    const text = _jsxs(_Fragment, { children: ["Conversation is assigned to ", agentLink] });
    return _jsx(LogEntry, { entry: entry, text: text });
};
